import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo } from 'react';
import MuiMenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import useStyles from './styles';
import { Avatar } from '../index';

var MenuItem = function (props) {
  var classes = useStyles(props);

  var hide = props.hide,
      endIcon = props.endIcon,
      icon = props.icon,
      description = props.description,
      name = props.name,
      id = props.id,
      justContent = props.justContent,
      avatar = props.avatar,
      image = props.image,
      rest = _objectWithoutPropertiesLoose(props, ["hide", "endIcon", "icon", "description", "name", "id", "justContent", "avatar", "image"]);

  if (hide) return null;

  if (justContent) {
    return (
      /*#__PURE__*/
      // @ts-ignore
      React.createElement("div", _extends({
        key: id,
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, rest, {
        className: classes.root
      }), !!icon && /*#__PURE__*/React.createElement(ListItemIcon, null, icon), !!avatar && /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Avatar, {
        src: avatar,
        size: 'small'
      })), !!image && /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Avatar, {
        src: image,
        size: 'small',
        rounded: true
      })), /*#__PURE__*/React.createElement(ListItemText, {
        primary: name,
        secondary: description
      }), endIcon && /*#__PURE__*/React.createElement(ListItemIcon, null, endIcon))
    );
  }

  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(MuiMenuItem, _extends({
      key: id,
      classes: classes
    }, rest), !!icon && /*#__PURE__*/React.createElement(ListItemIcon, null, icon), !!avatar && /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Avatar, {
      src: avatar,
      size: 'small'
    })), !!image && /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Avatar, {
      src: image,
      size: 'small',
      rounded: true
    })), /*#__PURE__*/React.createElement(ListItemText, {
      primary: name,
      secondary: description
    }), !!endIcon && /*#__PURE__*/React.createElement(ListItemIcon, null, endIcon))
  );
};

export default /*#__PURE__*/memo(MenuItem);